import React, { useMemo } from 'react'
import { View, StyleSheet, TouchableOpacity, ViewPropTypes } from 'react-native'
import { Dialog } from 'evergreen-ui'
import PropTypes from 'prop-types'
import { useTheme } from '../../theming/ThemeProvider'
import { Txt, Icon } from '..'
import { usePlatforms } from '../../hooks/usePlatforms'
import NavigationTopbar from '../NavigationTopbar'
import { ModalContainer } from './styles'

export default function Modal (props) {
  const {
    open,
    children,
    title,
    onClose,
    hideArrow,
    containerStyle,
    footer
  } = props

  const { isTablet } = usePlatforms()
  const { theme } = useTheme()

  const styles = useStyles(theme)

  const modalStyles = useMemo(() => isTablet
    ? {
      boxShadow: 'none'
    } : {
      width: '100%',
      height: '100%',
      maxWidth: '100%',
      maxHeight: '100%'
    }, [isTablet])

  return (
    <Dialog
      isShown={open}
      hasClose
      preventBodyScrolling
      onCloseComplete={() => onClose()}
      hasFooter={Boolean(footer)}
      footer={footer}
      containerProps={{
        style: {
          margin: 'auto',
          backgroundColor: theme.WHITE,
          padding: 20,
          ...modalStyles,
          ...containerStyle
        }
      }}
      title={title}
      header={isTablet ? (
        <View style={styles.header}>
          <Txt
            text={title}
            identity='h4'
          />
          <TouchableOpacity activeOpacity={0.8} onPress={onClose}>
            <Icon
              name='Exit'
              width={14}
              height={14}
            />
          </TouchableOpacity>
        </View>
      ) : (
        <View>
          {!hideArrow && (
            <NavigationTopbar
              onGoBack={() => onClose()}
            />
          )}
          {Boolean(title) && (
            <View>
              <Txt
                text={title}
                identity='h3'
              />
            </View>
          )}
        </View>
      )}
    >
      <ModalContainer className='modal' style={styles.container}>
        {children}
      </ModalContainer>
    </Dialog>
  )
}

const useStyles = (theme) => StyleSheet.create({
  modal: {
    margin: 'auto'
  },
  fullViewModal: {
    width: '100%',
    height: '100%'
  },
  container: {
    marginHorizontal: 20,
    backgroundColor: theme.WHITE
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    flex: 1
  }
})

Modal.propTypes = {
  open: PropTypes.bool,
  children: PropTypes.any,
  title: PropTypes.string,
  onClose: PropTypes.func,
  hideArrow: PropTypes.bool,
  containerStyle: ViewPropTypes.style,
  footer: PropTypes.any
}

Modal.defaultProps = {
  open: false,
  children: null,
  title: '',
  onClose: () => {},
  hideArrow: false,
  containerStyle: {},
  footer: null
}
